import { useState, useEffect } from 'react'
import { Modal, Row, Col, Form, Button, Spinner } from 'react-bootstrap'
import { useRouter } from 'next/router';
import { Request } from '@group-devs/yfp7-global-modules'
import Authenticator from '@group-devs/yfp7-authenticator'

import Recaptcha from '../general/Recaptcha';

const request = new Request(process.env.apiDomain)

function ModalTvc (props) {

    let site = props.global.site

    const { data: ownerAccount } = request.account.swrAccountProfile(site ? site.accountId : '')

    const router = useRouter()
    const [verified, setVerified] = useState(false)
    const [validationUrl, setUrl] = useState('')
    const [loading, setLoading] = useState(false)

    const [data, setData] = useState({
        firstname: '',  
        lastname: '',
        email: '',
    })
    const [errorMsg, setErrorMsg] = useState({
        firstname: '',  
        lastname: '',
        email: '',
        recaptcha: '',
    })

    useEffect(() => {
        let url, host;
        host = new URL(window.location.href);
        url  = new URL(`${host.protocol}//${host.host}/api/post`);
        url.searchParams.append('action', 'optin')
        setUrl(url)
    }, [])

    const handleChange = (evt) => {
        const value = evt.target.value
        setData({
          ...data,
          [evt.target.name]: value
        })
    }

    const checkVerification = verified => {
        setVerified(verified)
        setErrorMsg({})
    }

    const checkErrMsgs = () => {
        var err = 0;
        const errList = Object.entries(errorMsg).map(([key,value])=>{
            if (value != null || value != "")
                err++;
        },[err])
  
        if (err)
            return false
        
        return true
    }

    const fetchResponseErrors = (responseErr) =>
    {
        let errData = {};

        const errList = Object.entries(responseErr).map(([key,value])=>{
            const errField = key.toString();
            const errValue = value.toString();
            var errors = Object.assign({}, errData);
            errors[errField] = errValue;
            errData = errors;
        })
        
        setErrorMsg(errData);
    }

    function inputValidation () {
        let err = 0
        var errors = {};

        if (data.firstname == "") {
            errors['firstname'] = "Firstname is required.";
            err++;
        }

        if (data.lastname == "") {
            errors['lastname'] = "Lastname is required.";
            err++;
        }

        if (data.email == "") {
            errors['email'] = "Email is required.";
            err++;
        }

        if (!verified) {
            errors['recaptcha'] = "Required.";
        }

        setErrorMsg(errors)

        if (err)
            return false
        
        return true
    }

    async function onSubmit () {
        
        if (loading) return;  // Prevent submission if already loading

        setLoading(true); // Set loading to true when the form is being submitted

        if (inputValidation() && checkErrMsgs()) {
            let newData, post, meta_data, metaDataDetails

            metaDataDetails = {
            code: site.site.code,
            name: site.site.name
            }

            meta_data = Buffer.from(JSON.stringify(metaDataDetails)).toString('base64')

            newData = {
            websiteId: site.websiteId,
            meta_data: meta_data,
            userId: ownerAccount ? ownerAccount.userId : ''
            }

            post = {...data, ...newData}

            const _response = await fetch(validationUrl, {
                method: 'POST',
                headers: Authenticator.getJSONHeaders(),
                body: JSON.stringify(post)
              })
              .then((response) => { return response.json() })
              .catch(function(error) { console.log(error) })
              
              setLoading(false); // Set loading to false once the response is received or an error occurs

              let newResponse = JSON.parse(_response);

              if (typeof newResponse === 'object'){
                if (newResponse.code === 200) {
                    router.push("/vitamin-checklist/confirmation")
                }else{
                    if (Array.isArray(newResponse.error)){
                        let errData = {};
                        newResponse.error.forEach((errObj) => {
                            Object.entries(errObj).forEach(([key, value]) => {
                                errData[key] = Array.isArray(value) ? value[0] : value;
                            });
                        });
                        setErrorMsg(errData);

                    }else if (typeof newResponse.error === 'string'){
                        fetchResponseErrors(JSON.parse(newResponse.error));

                    }else if (typeof newResponse.error === 'object'){
                        fetchResponseErrors(newResponse.error);
                    }
                }
            }
        }else {
            setLoading(false); // Ensure loading is stopped if validation fails
        }
    }

return (
<div>
    <div className="tvc__Modal">
        <Modal.Header className="border-bottom-0" closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-5">
            <Row>
                <Col lg={4} md={4} sm={12}>
                <img className="tvc__workBook-img mr-3 img-fluid ml-auto mr-auto d-block" src="../images/tvc/img-download-free-ebook01.png" alt="Ebook" />
                </Col>
                <Col lg={8} md={8} sm={12}>
                <h4>Download the Vitamin Checklist and</h4>
                <h3 className="text-orange">LEARN HOW TO CHOOSE A HIGH <br className="d-none d-lg-block d-xl-none"/>QUALITY FOOD SUPPLEMENT</h3>
                <hr />
                <p>Enter your details below so I can send you this critically important e-book.</p>
                <Form>
                    <Form.Group controlId="firstname">
                        <Form.Control
                            type="text"
                            placeholder="Enter your First Name"
                            name="firstname"
                            value={data.firstname}
                            onChange={handleChange}
                        />
                        <Form.Text className="text-danger">{errorMsg.firstname}</Form.Text>
                    </Form.Group>
                    <Form.Group controlId="lastname">
                        <Form.Control
                            type="text"
                            placeholder="Enter your Last Name"
                            name="lastname"
                            value={data.lastname}
                            onChange={handleChange}
                        />
                        <Form.Text className="text-danger">{errorMsg.lastname}</Form.Text>
                    </Form.Group>
                    <Form.Group controlId="email">
                        <Form.Control
                            className="form-control"
                            type="email"
                            placeholder="Enter your Email Address"
                            name="email"
                            value={data.email}
                            onChange={handleChange}
                        />
                        <Form.Text className="text-danger">{errorMsg.email}</Form.Text>
                    </Form.Group>
                    
                    <Form.Group>
                        <Recaptcha checkVerification={checkVerification} />
                        <Form.Text className="text-danger">{errorMsg.recaptcha}</Form.Text>
                    </Form.Group>

                    <Button variant="warning mt-4 mb-2" type="button" onClick={onSubmit} disabled={loading}>
                        <strong>{loading ? "Processing..." : "Send me the Checklist"}</strong>
                        {loading && <Spinner animation="border" size="sm" className="ml-2" />}
                    </Button>
                    
                    <br />
                    <small className="font-weight-normal">Your email is safe with me. I'll never sell or rent your details to anyone, for any reason ever!</small>
                </Form>
                </Col>
            </Row>
        </Modal.Body>
    </div>
    <style jsx global>{`
        .form-control{
        	width: 80%!important;
        }
        .tvc__Modal .btn{
			font-size: 1.5rem;
			background: #FFD504;
			padding: 5px 35px;
			border-radius: 5px;
			color: #C20000;
        }
        .tvc__Modal .btn:hover{
            background: #D9B300;
        }
        .modal-header .close{
			opacity: 1;
			background: #000;
			border: 2px solid #fff;
			color: #fff;
			font-size: 1.2rem;
			padding: 0px 6px 1px 5px;
			margin: -30px -30px 0px 0px;
			border-radius: 50%;
        }
        .modal-lg {
        	max-width: 900px;
        }
        @media(max-width: 480px){
            .tvc__Modal .btn{
            font-size: 1.1rem;
        }
    }
        `}
    </style>
    <style jsx>{`
        .tvc__workBook-img{
        	margin-top: 70px;
        }
        h3{
			font-family: 'Oswald', sans-serif;
			font-size:2.5rem;
        }
        hr{
        	border-bottom: 1px solid #7BB709;
        }
        p{
            font-weight:600;
        }
			@media(max-width: 768px){
			.tvc__workBook-img{
				margin-top: 20px;
				width:50%;
			}
        }
        `}
    </style>
</div>
);
}
export default ModalTvc;